module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/UUip7W/tc-custom/9781398420465.jpg?1705540958202",
      "alt": "This image is the cover for the book The Jackdaw Detail"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Jackdaw Detail\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Peru, 2005. The towering mountains and deep, forested valleys of La Convención Province provide sanctuary for a dangerous criminal organisation with sufficient military capability to challenge government forces. An elite unit of British SAS are tasked to implement a solution. Their ground-breaking new equipment offers a decisive advantage and enables an unorthodox covert approach, but its untested nature also brings complications. Soon the British team find themselves ensnared in a web of corruption and conflicting interest, where the only way forward is to elevate the crisis to a chaotic conclusion. The Jackdaw Detail weaves between political, tactical and financial motives, as soldiers and civilians alike are drawn into an ever-thickening plot.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ryan M Love\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Ryan M Love was born in Kent. Following an education in horticulture, he worked principally as a gardener until a keen interest in modern military history inspired him to begin writing fiction. Having a passion for the outdoor life, he is an avid mountain biker, snowboarder and trail runner. He currently lives in Wales, just outside the Brecon Beacons National Park.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0